.results {
  margin-top: var(--spacing-4);
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid var(--color-grey-lighter);
  border-radius: 8px;
}

.row {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-bottom: 1px solid var(--color-grey-lightest);
  background: none;
  text-align: left;
  cursor: pointer;
}

.row:last-child {
  border-bottom: none;
}

.row:hover,
.row:focus-visible {
  background: var(--color-primary-lightest);
}

.row[aria-pressed="true"] {
  background: var(--color-primary-lightest);
}

.rowMain {
  min-width: 0;
  flex: 1;
}

.rowName {
  display: block;
  font-size: var(--font-size-m);
  color: var(--color-text);
}

.rowMeta {
  display: block;
  font-size: var(--font-size-s);
  color: var(--color-grey);
}

.note {
  display: block;
  padding: 14px 12px;
  font-size: var(--font-size-s);
  color: var(--color-grey);
}

.foot {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-2);
  margin-top: var(--spacing-4);
}
